"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Models = require("./models/index");
//# sourceMappingURL=index.js.map